import { Select } from "@mui/material";
import type { FC } from "react";
import type { UsableAccountPersonField } from "../../../../server/supabase-segment-field-service";
import type { Condition } from "../../../../types/segment-schema";
import { AutocompleteOpSelect } from "./autocomplete";
import { BooleanSelect } from "./boolean";
import { DateOpSelect } from "./date";

export const OperationSelect: FC<{
  condition: Condition;
  handleFieldChange: (value: Partial<Condition>) => void;
  disabled?: boolean;
  fieldType?: UsableAccountPersonField["field_type"];
}> = ({ condition, handleFieldChange, disabled, fieldType }) => {
  switch (fieldType) {
    case "TEXT":
    case "COUNTRY":
      return (
        <AutocompleteOpSelect
          condition={condition}
          handleFieldChange={handleFieldChange}
          disabled={disabled}
          fieldType={fieldType}
        />
      );
    case "MONTH_DAY":
    case "DATE":
      return (
        <DateOpSelect
          fieldType={fieldType}
          condition={condition}
          handleFieldChange={handleFieldChange}
          disabled={disabled}
        />
      );
    case "BOOLEAN":
      return (
        <BooleanSelect
          condition={condition}
          handleFieldChange={handleFieldChange}
          disabled={disabled}
        />
      );
    case "ADDRESS":
    case undefined:
    case null:
      return <Select disabled={true} value="" variant="outlined"></Select>;
  }
};
